import qs from 'qs';

import { makePost, makePut, makeGet } from './ServiceManager';

export const updateErrorReport = async (report) => {
  const result = await makePut('service/report', { report });
  return result;
};

export const insertErrorReport = async (report) => {
  const result = await makePost('service/report', { report });
  return result;
};

export const getErrorReport = async (id) => {
  const result = await makeGet(`service/report/${id}`);
  return result;
};

export const getErrorReports = async (params) => {
  const paramsQS = qs.stringify(params);
  const result = await makeGet(`service/report?${paramsQS}`);
  return result;
};



// WEBPACK FOOTER //
// ./src/services/AdErrorReportService.js